import {
  isUserFetching,
  isGlobalOfferFlowEnabled
} from "../../../../redux/bridge/selectors";
import { connect } from "react-redux";
import React from "react";
import styled from "styled-components";
import { getCurrentLanguage } from "../../../../redux/locale/selectors";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as routerSelectors } from "../../../../redux/router";
import { studentBannerPadding } from "../../../components/mixins";

const Frame = styled.div`
  ${props =>
    studentBannerPadding(props.showStudentBanner, props.isSmall, props.native)};
`;

function AdminTab({
  bridgeUserFetching,
  currentLanguage,
  native,
  globalOfferFlowEnabled,
  enableStudentBanner,
  isSmall
}) {
  if (bridgeUserFetching) {
    // Candy stripe rendering handled outside this component
    return <div />;
  }

  const jigsawSessionId = window.jigsawSessionId;
  return (
    <Frame
      showStudentBanner={enableStudentBanner}
      isSmall={isSmall}
      native={native}
    >
      <admin-dashboard
        jigsawsessionid={jigsawSessionId}
        lang={currentLanguage.short}
        globalOfferFlowEnabled={globalOfferFlowEnabled}
      ></admin-dashboard>
    </Frame>
  );
}

export default connect(state => ({
  bridgeUserFetching: isUserFetching(state),
  currentLanguage: getCurrentLanguage(state),
  globalOfferFlowEnabled: isGlobalOfferFlowEnabled(state),
  native: routerSelectors.isNative(state),
  brandHasSwimlanes: brandSelectors.brandHasSwimlanes(state),
  enableStudentBanner: brandSelectors.getBrandValue(
    state,
    "StudentHome.enabled"
  )
}))(AdminTab);
